module.exports = __webpack_public_path__ + "images/emoji/shaved_ice.1fdcd8cb02dedec81d4d.png";